
 export class Zonos {
     constructor(cart) {
         // iGlobal Welcome Mat Script
         // Authored by iGlobal Stores (www.iglobalstores.com)
         // Copyright iGlobal Stores 2016
         // Store specific settings:
         // Replace with your STORE ID
         this.cart = cart;
         // All countries you sell to, including the US
         this.ig_countries = {
             "AL": "Albania",
             "AS": "American Samoa",
             "AD": "Andorra",
             "AO": "Angola",
             "AI": "Anguilla",
             "AG": "Antigua",
             "AR": "Argentina",
             "AM": "Armenia",
             "AW": "Aruba",
             "AU": "Australia",
             "AT": "Austria",
             "AZ": "Azerbaijan",
             "BS": "Bahamas",
             "BH": "Bahrain",
             "BD": "Bangladesh",
             "BB": "Barbados",
             "BE": "Belgium",
             "BZ": "Belize",
             "BJ": "Benin",
             "BM": "Bermuda",
             "BT": "Bhutan",
             "BO": "Bolivia",
             "BQ": "Bonaire, St. Eustatius & Saba",
             "BW": "Botswana",
             "BR": "Brazil",
             "BN": "Brunei",
             "BG": "Bulgaria",
             "BF": "Burkina Faso",
             "BI": "Burundi",
             "KH": "Cambodia",
             "CM": "Cameroon",
             "CA": "Canada",
             "CV": "Cape Verde",
             "KY": "Cayman Islands",
             "TD": "Chad",
             "CL": "Chile",
             "CN": "China - People's Republic of",
             "CO": "Colombia",
             "KM": "Comoros",
             "CG": "Congo",
             "CK": "Cook Islands",
             "CR": "Costa Rica",
             "HR": "Croatia",
             "CW": "Curaçao",
             "CY": "Cyprus",
             "CZ": "Czech Republic",
             "DK": "Denmark",
             "DJ": "Djibouti",
             "DM": "Dominica",
             "DO": "Dominican Republic",
             "EC": "Ecuador",
             "EG": "Egypt",
             "SV": "El Salvador",
             "GQ": "Equatorial Guinea",
             "ER": "Eritrea",
             "EE": "Estonia",
             "ET": "Ethiopia",
             "FK": "Falkland Islands",
             "FO": "Faroe Islands (Denmark)",
             "FJ": "Fiji",
             "FI": "Finland",
             "FR": "France",
             "GF": "French Guiana",
             "GA": "Gabon",
             "GM": "Gambia",
             "DE": "Germany",
             "GI": "Gibraltar",
             "GR": "Greece",
             "GL": "Greenland (Denmark)",
             "GD": "Grenada",
             "GP": "Guadeloupe",
             "GT": "Guatemala",
             "GG": "Guernsey",
             "GN": "Guinea",
             "GY": "Guyana",
             "HT": "Haiti",
             "HN": "Honduras",
             "HK": "Hong Kong",
             "HU": "Hungary",
             "IS": "Iceland",
             "IN": "India",
             "ID": "Indonesia",
             "IE": "Ireland - Republic Of",
             "IL": "Israel",
             "IT": "Italy",
             "JM": "Jamaica",
             "JP": "Japan",
             "JE": "Jersey",
             "JO": "Jordan",
             "KZ": "Kazakhstan",
             "KE": "Kenya",
             "KI": "Kiribati",
             "KR": "Korea, Republic of (South Korea)",
             "KW": "Kuwait",
             "KG": "Kyrgyzstan",
             "LA": "Laos",
             "LV": "Latvia",
             "LS": "Lesotho",
             "LR": "Liberia",
             "LI": "Liechtenstein",
             "LT": "Lithuania",
             "LU": "Luxembourg",
             "MO": "Macau",
             "MK": "Macedonia",
             "MG": "Madagascar",
             "MW": "Malawi",
             "MY": "Malaysia",
             "MV": "Maldives",
             "ML": "Mali",
             "MT": "Malta",
             "MH": "Marshall Islands",
             "MQ": "Martinique",
             "MR": "Mauritania",
             "MU": "Mauritius",
             "MX": "Mexico",
             "FM": "Micronesia - Federated States of",
             "MD": "Moldova",
             "MC": "Monaco",
             "MN": "Mongolia",
             "MS": "Montserrat",
             "MA": "Morocco",
             "MZ": "Mozambique",
             "NP": "Nepal",
             "NL": "Netherlands (Holland)",
             "NC": "New Caledonia",
             "NZ": "New Zealand",
             "NI": "Nicaragua",
             "NE": "Niger",
             "NG": "Nigeria",
             "MP": "Northern Mariana Islands",
             "NO": "Norway",
             "OM": "Oman",
             "PK": "Pakistan",
             "PW": "Palau",
             "PA": "Panama",
             "PG": "Papua New Guinea",
             "PY": "Paraguay",
             "PE": "Peru",
             "PH": "Philippines",
             "PL": "Poland",
             "PT": "Portugal",
             "PR": "Puerto Rico",
             "QA": "Qatar",
             "RO": "Romania",
             "RU": "Russia",
             "RW": "Rwanda",
             "SM": "San Marino",
             "ST": "Sao Tome & Principe",
             "SA": "Saudi Arabia",
             "SN": "Senegal",
             "SC": "Seychelles",
             "SG": "Singapore",
             "SK": "Slovakia",
             "SI": "Slovenia",
             "ZA": "South Africa",
             "ES": "Spain",
             "LK": "Sri Lanka",
             "BL": "St. Barthelemy",
             "KN": "St. Kitts and Nevis",
             "LC": "St. Lucia",
             "MF": "St. Maarten",
             "VC": "St. Vincent",
             "SR": "Suriname",
             "SZ": "Swaziland",
             "SE": "Sweden",
             "CH": "Switzerland",
             "PF": "Tahiti",
             "TW": "Taiwan",
             "TJ": "Tajikistan",
             "TZ": "Tanzania",
             "TH": "Thailand",
             "TL": "Timor-Leste",
             "TG": "Togo",
             "TO": "Tonga",
             "TT": "Trinidad and Tobago",
             "TN": "Tunisia",
             "TR": "Turkey",
             "TM": "Turkmenistan",
             "TC": "Turks and Caicos Islands",
             "UA": "Ukraine",
             "AE": "United Arab Emirates",
             "GB": "United Kingdom",
             "US": "United States",
             "UY": "Uruguay",
             "UZ": "Uzbekistan",
             "VU": "Vanuatu",
             "VE": "Venezuela",
             "VN": "Vietnam",
             "VG": "Virgin Islands (British)",
             "VI": "Virgin Islands (U.S.)",
             "WS": "Western Samoa",
             "YE": "Yemen",
             "ZM": "Zambia",
             "ZW": "Zimbabwe",
             "RS": "Serbia"
         };
         this.eu_country = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB'];
         this.acceptTermsCheckbox = this.acceptTermsCheckbox.bind(this);
         this.handleCart = this.handleCart.bind(this);
         this.handleSnifferRemove = this.handleSnifferRemove.bind(this);
         this.ig_domesticCountryCodes = ['US'];
         this.ig_country = this.getCookie('localization');
         this.handleCart();
         $("body").on('change', '#country_code', (e) => {
            this.ig_country = this.getCookie('localization');
            this.handleCart();
        });
        $('.prevent-checkout-click').on('click', this.preventCheckoutForEuCountry);
        $('.accept-terms-checkbox').on('click', this.acceptTermsCheckbox);
        $('.au-sniffer-remove').on('click', this.handleSnifferRemove);

        if(this.ig_country == 'AU') {
            const showAuSnippetCookie = this.getCookie('show_au_snippet');
            if(showAuSnippetCookie === null) {
              $('#snifferContainer').removeClass('d-none');
            }
          }
     }

     handleSnifferRemove() {
      this.setCookie('show_au_snippet', true, 1);
      $('#snifferContainer').addClass('d-none');
     }

     getCookie(name) {
        var pattern = RegExp(name + "=.[^;]*")
        var matched = document.cookie.match(pattern)
        if(matched){
            var cookie = matched[0].split('=')
            return cookie[1]
        }
        return null;
    }

    setCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
      }

     handleCart() {
         $('.cart-buttons .checkout-button-message').html('');
         this.cart.getData().then((data) => {
             if(jQuery.isEmptyObject(us_checkout_only) === true) {
                 return;
             }
             
             let disableCheckout = false;
             let showBundleMessage = false;
             let showProductMessage = false;
             for(let i = 0; i < data.items.length; i++) {
                 const item = data.items[i];
                 if(us_checkout_only[item.handle] == true) {
                     if(this.ig_country !== 'US') {
                         if(item.properties.hasOwnProperty('_bundle')) {
                             disableCheckout = true;
                             showBundleMessage = true;
                         } else {
                             disableCheckout = true;
                             showProductMessage = true;
                         }
                     } 
                 }
             }
             if(showProductMessage === true && showBundleMessage === true) {
                $('.international-message-wrapper').html(single_product_message_delux_serum);
             } else if(showBundleMessage === true) {
                $('.international-message-wrapper').html(bundle_message_delux_serum);
                
             } else if (showProductMessage === true) {
                $('.international-message-wrapper').html(single_product_message_delux_serum);
             } else {
                // silence
             }
 
             if(disableCheckout) {
                 $('.v4-cart-form .affirm-wrapper').addClass('d-none');
                 $('.v4-cart-form .cart-disclaimer').addClass('d-none');
                 $('.cart-buttons').find('[name="checkout"]').addClass('d-none');
                 $('.fictitious-checkout').addClass('d-none');
                 $('.continue-shopping-button-wrapper').addClass('d-none');
                 $('.clear-cart-wrapper').addClass('cart-buttons');
                 $('.clear-cart-wrapper').find('.hyperlink-gold').addClass('clear-cart-cta');
                 $('.accept-terms-wrapper').addClass('d-none');
                 $('.checkout-cta-wrapper').addClass('d-none');
                 $('.mobile-checkout-controller').addClass('d-none');
             } else {
                $('.checkout-cta-wrapper').removeClass('d-none');
                $('.mobile-checkout-controller').removeClass('d-none');
                 $('.v4-cart-form .affirm-wrapper').removeClass('d-none');
                 $('.v4-cart-form .cart-disclaimer').removeClass('d-none');
                 $('.cart-buttons').find('[name="checkout"]').removeClass('d-none');
                 $('.fictitious-checkout').removeClass('d-none');
                 $('.continue-shopping-button-wrapper').removeClass('d-none');
                 $('.clear-cart-wrapper').removeClass('cart-buttons');
                 $('.clear-cart-wrapper').find('.hyperlink-gold').removeClass('clear-cart-cta');
                 $('.international-message-wrapper').html(' ');
             }
             this.checkEuCountry(this.ig_country);

             $('.cart-buttons').find('[name="checkout"]').prop('disabled', disableCheckout);
         });
     }
 
     preventCheckoutForEuCountry() {
         if($(this).hasClass('active')) {
             $('.cart-buttons').addClass("error");
             $('.cart-buttons .error-message').text('Please accept our terms and conditions.');
             $('.accept-terms-checkbox').focus();
         } else {
             $('.cart-buttons').removeClass("error");
             $('.cart-buttons .error-message').text('');
         }
     }
 
     acceptTermsCheckbox() {
         const isChecked = $('.accept-terms-checkbox').prop('checked');
 
         if (isChecked) {
             $('.prevent-checkout-click').removeClass('active');
             this.preventCheckoutForEuCountry();
         }
         else {
             $('.prevent-checkout-click').addClass('active');
             this.preventCheckoutForEuCountry();
         }
     }
 
     checkEuCountry(countryCode) {
         const euCountry = $.inArray(countryCode, this.eu_country);
         if(euCountry !== -1) {
            document.getElementsByClassName('accept-terms-checkbox')[0].checked = false;
             $('.prevent-checkout-click').addClass('active');
             $('.accept-terms-wrapper').removeClass('d-none');
         } else {
             $('.prevent-checkout-click').removeClass('active');
             $('.accept-terms-wrapper').addClass('d-none');
         }
     }
 }